import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_PRINTER_2: GlameraIconDefinition = {
  name: 'printer-2',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-printer-2-body" d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
    <path class="glm-printer-2-top" d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
    <rect class="glm-printer-2-output" x="6" y="14" width="12" height="8" rx="1"></rect>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-printer-2-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './printer-2.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class Printer2IconComponent extends GlameraIconBase {
  readonly iconDef = GLM_PRINTER_2;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
